import { HeadingSection } from "./HeadingSection";
import { DividerSection } from "./DividerSection";
import { StatusTableSection } from "./StatusTableSection";
import { CommandsSection } from "./CommandsSection";
import { CodeBlockSection } from "./CodeBlockSection";
import { SuggestedMessageSection } from "./SuggestedMessageSection";
import { ProsConsSection } from "./ProsConsSection";
import { OptionsSection } from "./OptionsSection";
import { TextSection } from "./TextSection";
import { DesignPreviewSection } from "./DesignPreviewSection";

export function SectionRenderer({ section, index, onSendMessage }) {
  switch (section.type) {
    case "heading":
      return <HeadingSection section={section} />;
    case "text":
      return <TextSection section={section} />;
    case "divider":
      return <DividerSection />;
    case "status_table":
      return <StatusTableSection section={section} />;
    case "commands":
      return <CommandsSection section={section} index={index} />;
    case "code_block":
      return <CodeBlockSection section={section} index={index} />;
    case "suggested_message":
      return <SuggestedMessageSection section={section} index={index} onSendMessage={onSendMessage} />;
    case "pros_cons":
      return <ProsConsSection section={section} />;
    case "options":
      return <OptionsSection section={section} onSendMessage={onSendMessage} />;
    case "design_preview":
      return <DesignPreviewSection section={section} />;
    default:
      return null;
  }
}
